import React from 'react';
import { toast } from 'react-toastify';

export const typeNotification = {
    success: 'success',
    error: 'error',
};

const showNotification = (text, type = 'success') => {
    toast[type](text, {
        autoClose: 8000,
        className: 'customNotification',
        closeButton: false,
        position: 'bottom-right',
    });
};

export default showNotification;
